import withSearchResult from '../common/with-search-result';
import { SearchResultItemDetails } from '../common/search-result';

function AcademySearchBarResult({
  content,
  name,
  tags,
  contentType,
  parentType,
  parentName,
  contentLabelOverrides,
  isExternal,
}) {
  if (contentType == null) {
    console.log('Error. Tried to render an item type that does not exist.');
    return;
  }

  return (
    <SearchResultItemDetails
      content={content}
      dim={false}
      matchedTagContent={tags}
      name={name}
      type={contentType}
      parentType={parentType}
      parentName={parentName}
      contentLabelOverrides={contentLabelOverrides}
      isExternal={isExternal}
    />
  );
}

export default withSearchResult(AcademySearchBarResult, true);
